import React, { useEffect, useState } from "react";
import EmailLoginModal from "./EmailLoginModal";

const SEEN_KEY = "tt_save_progress_seen";

export default function SaveProgressPrompt({ trigger }) {
  // `trigger` should flip from false -> true when first melody is completed
  const [show, setShow] = useState(false);
  const [loginOpen, setLoginOpen] = useState(false);

  useEffect(() => {
    if (trigger && !localStorage.getItem(SEEN_KEY)) {
      setShow(true);
    }
  }, [trigger]);

  const dismiss = () => {
    localStorage.setItem(SEEN_KEY, "1");
    setShow(false);
  };

  if (!show) return null;

  return (
    <>
      <div className="fixed inset-0 z-[900] flex items-end justify-center p-4">
        <div className="max-w-xl w-full bg-white rounded-2xl shadow-xl p-5 border">
          <h3 className="text-lg font-semibold">🎉 Great job!</h3>
          <p className="text-gray-700 mt-1">
            You completed your first melody. <strong>Save your progress</strong> with a parent
            email so you can continue on any device and unlock premium later.
          </p>
          <div className="flex gap-2 justify-end mt-4">
            <button onClick={dismiss} className="px-4 py-2 rounded-lg border">Maybe later</button>
            <button onClick={() => { setLoginOpen(true); }} className="px-4 py-2 rounded-lg bg-amber-400 hover:bg-amber-300 font-medium">
              Save progress
            </button>
          </div>
        </div>
      </div>

      <EmailLoginModal
        open={loginOpen}
        onClose={() => { setLoginOpen(false); dismiss(); }}
        onLoggedIn={() => {}}
      />
    </>
  );
}
